import api from 'app/utils/api';

export class WirePaymentsService {
  public async getWirePayments(query: any) {
    return api.get(`/wire-payments?${query}`);
  }
  public async updateProcessingStatus(
    id: string,
    newStatus: string,
    processingStatus: any
  ) {
    const newProcessingStatus = {
      ...processingStatus,
      status: newStatus,
    };
    return api.patch(`/wire-payments/${id}/processing-status`, {
      processingStatus: newProcessingStatus,
    });
  }
  public async getWirePaymentById(id: string) {
    return api.get(`/wire-payments/${id}`);
  }
  public async patchRemarks(id: string, remarks: string) {
    return api.patch(`/wire-payments/${id}/remarks`, {
      remarks,
    });
  }

  public async sendWirePaymentEmail(id: string) {
    return api.post(`/wire-payments/${id}/send-email`);
  }

  public async checkContractCare(transactionId: string) {
    return api.get(`/wire-payments/check-contract-care/${transactionId}`);
  }
}
